export function catchError(error) {
	console.log(error); // eslint-disable-line no-console
}
